// React & Routing
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter';

// HTTP Client
import axios from 'axios';

// React-Bootstrap Components
import {
    Breadcrumb, Row, Col, Card, Image as Images
} from 'react-bootstrap';

// RSuite UI Components
import {
    Steps, Panel, Input, Button, IconButton,
    Stack, VStack, HStack, SelectPicker,
    Radio, RadioGroup, Checkbox, CheckboxGroup,
    InputNumber, Text, MaskedInput,
    Modal, Loader, Divider
} from 'rsuite';

// Other Libraries
import Swal from 'sweetalert2';
import $ from 'jquery';
import Cropper from 'react-easy-crop';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

// Static Assets
import QRcode from '../../images/lineqrcode.jpg';
import ImageSize from '../../images/user.png';

class EditPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            content: null,
            modal: null,
            image: null,
            croppedImage: ImageSize,
            croppedArea: null,
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation: 0,
            selectedConsent: { consent1: false, consent2: false },
            selectedRights: [],
            schools: [],
            ethnics: [],
            reg_province_selection: [],
            reg_amphur_selection: [],
            reg_tambon_selection: [],
            temp_province_selection: [],
            temp_amphur_selection: [],
            temp_tambon_selection: [],
            existing: ''
        };
    }

    async componentDidMount() {
        await this.onRead({ mode: 'read' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRead = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const statusResponse = await axios.get(`${process.env.REACT_APP_API}/status/1`, this.state.authHeader);
                const statusData = statusResponse.data;

                const applicantsResponse = await axios.get(`${process.env.REACT_APP_API}/application/edit/${this.props.params.id}`, this.state.authHeader);
                const applicantsData = applicantsResponse.data;
                const isExisting = applicantsData.count > 0;
                const applicantData = applicantsResponse.data.rows[0];

                const initialState = {
                    // User Login
                    login_first_name: applicantData.first_name,
                    login_last_name: applicantData.last_name,

                    // Status
                    status: statusData[0].status,
                    applicant_id: applicantData.applicant_id,
                    year: statusData[0].default_year,
                    existing: isExisting,

                    // User Information
                    croppedImage: `${process.env.REACT_APP_UPLOAD}/${applicantData.path}`,
                    id: applicantData.id,
                    rights1: applicantData.rights1,
                    rights2: applicantData.rights2,
                    rights3: applicantData.rights3,
                    rights4: applicantData.rights4,
                    id_card_number: applicantData.id_card_number,
                    prefix: applicantData.prefix,
                    first_name: applicantData.first_name,
                    last_name: applicantData.last_name,
                    nickname: applicantData.nickname,
                    date_of_birth: applicantData.date_of_birth,
                    ethnicity: applicantData.ethnicity,
                    ethnicity_other: applicantData.ethnicity_other,
                    phone: applicantData.phone,
                    is_family_residence: applicantData.is_family_residence,
                    family_residence_rai: applicantData.family_residence_rai,
                    family_residence_ngan: applicantData.family_residence_ngan,
                    family_residence_wah: applicantData.family_residence_wah,
                    is_family_work: applicantData.is_family_work,
                    family_work_rai: applicantData.family_work_rai,
                    family_work_ngan: applicantData.family_work_ngan,
                    family_work_wah: applicantData.family_work_wah,
                    is_none_residence: applicantData.is_none_residence,
                    none_residence_rai: applicantData.none_residence_rai,
                    none_residence_ngan: applicantData.none_residence_ngan,
                    none_residence_wah: applicantData.none_residence_wah,
                    is_none_work: applicantData.is_none_work,
                    none_work_rai: applicantData.none_work_rai,
                    none_work_ngan: applicantData.none_work_ngan,
                    none_work_wah: applicantData.none_work_wah,
                    edu_level: applicantData.edu_level,
                    curr_institution: applicantData.curr_institution,
                    curr_field: applicantData.curr_field,
                    grades: applicantData.grades,
                    next_institution: applicantData.next_institution,
                    next_field: applicantData.next_field,
                    app_status: applicantData.app_status,
                    contactable: applicantData.contactable,
                    relationship_to_applicant: applicantData.relationship_to_applicant,
                    parent_status: applicantData.parent_status,
                    parent_status_1: applicantData.parent_status_1,
                    parent_status_2: applicantData.parent_status_2,
                    parent_status_3: applicantData.parent_status_3,
                    parent_status_4: applicantData.parent_status_4,
                    total_siblings: applicantData.total_siblings,
                    working_siblings: applicantData.working_siblings,
                    siblings_in_school: applicantData.siblings_in_school,
                    unemployed_siblings: applicantData.unemployed_siblings,
                    siblings_not_of_age: applicantData.siblings_not_of_age,
                    family_income_per_year: applicantData.family_income_per_year,
                    provider_full_name: applicantData.provider_full_name,
                    provider_relationship: applicantData.provider_relationship,
                    doitung_activities: applicantData.doitung_activities,
                    school_activities: applicantData.school_activities,
                    other_activities: applicantData.other_activities,
                    applicant_proj_no: applicantData.applicant_proj_no,
                    father_proj_no: applicantData.father_proj_no,
                    mother_proj_no: applicantData.mother_proj_no,
                    is_linegroup: true,

                    // Address
                    is_reg_address: applicantData.is_reg_address,
                    reg_house_number: applicantData.reg_house_number,
                    reg_village_no: applicantData.reg_village_no,
                    reg_village: applicantData.reg_village,
                    reg_village_name: applicantData.reg_village_name,
                    reg_province: applicantData.reg_province,
                    reg_province_id: applicantData.reg_province_id,
                    reg_amphur: applicantData.reg_amphur,
                    reg_amphur_id: applicantData.reg_amphur_id,
                    reg_tambon: applicantData.reg_tambon,
                    reg_tambon_id: applicantData.reg_tambon_id,
                    temp_house_number: applicantData.temp_house_number,
                    temp_village_no: applicantData.temp_village_no,
                    temp_village: applicantData.temp_village,
                    temp_village_name: applicantData.temp_village_name,
                    temp_province: applicantData.temp_province,
                    temp_province_id: applicantData.temp_province_id,
                    temp_amphur: applicantData.temp_amphur,
                    temp_amphur_id: applicantData.temp_amphur_id,
                    temp_tambon: applicantData.temp_tambon,
                    temp_tambon_id: applicantData.temp_tambon_id,

                    // Family details
                    father_full_name: applicantData.father_full_name,
                    father_age: applicantData.father_age,
                    father_occupation: applicantData.father_occupation,
                    father_workplace: applicantData.father_workplace,
                    father_phone: applicantData.father_phone,
                    mother_full_name: applicantData.mother_full_name,
                    mother_age: applicantData.mother_age,
                    mother_occupation: applicantData.mother_occupation,
                    mother_workplace: applicantData.mother_workplace,
                    mother_phone: applicantData.mother_phone,

                    // Rights details
                    father_rights4: applicantData.father_rights4,
                    rights_father_no: applicantData.rights_father_no,
                    rights_father_job_title: applicantData.rights_father_job_title,
                    rights_father_department: applicantData.rights_father_department,
                    rights_father_years: applicantData.rights_father_years,
                    mother_rights4: applicantData.mother_rights4,
                    rights_mother_no: applicantData.rights_mother_no,
                    rights_mother_job_title: applicantData.rights_mother_job_title,
                    rights_mother_department: applicantData.rights_mother_department,
                    rights_mother_years: applicantData.rights_mother_years,
                };

                for (const right of ['rights1', 'rights2', 'rights3', 'rights4']) {
                    if (this.state[right]) await this.handleRightsCheckboxChange(right);
                }

                await this.promisedSetState(initialState);
                await this.onRenderContent({ mode: 'read', step: 0 });
            } catch (error) {
                console.error("Error during initialization:", error);
            }
        }
    }

    getRightsValue() {
        const vals = [];
        if (this.state.rights1) vals.push("rights1");
        if (this.state.rights2) vals.push("rights2");
        if (this.state.rights3) vals.push("rights3");
        if (this.state.rights4) vals.push("rights4");
        return vals;
    }

    onRenderContent = async ({ mode, step }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })

            await Promise.all([
                this.fetchProvinces(),
                this.fetchAmphures('reg_amphur_selection', 'reg_tambon_selection', this.state.reg_province_id),
                this.fetchTambons('reg_tambon_selection', this.state.reg_amphur_id),
                this.fetchAmphures('temp_amphur_selection', 'temp_tambon_selection', this.state.temp_province_id),
                this.fetchTambons('temp_tambon_selection', this.state.temp_amphur_id),
                this.fetchSchools(),
                this.fetchEthnics(),
                this.fetchVillages()
            ]);

            await this.promisedSetState({
                content: (
                    <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item>ข้อมูลผู้สมัคร</Breadcrumb.Item>
                                    <Breadcrumb.Item>แก้ไข</Breadcrumb.Item>
                                    <Breadcrumb.Item active>{this.state.login_first_name} {this.state.login_last_name}</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row className="justify-content-center mt-3">
                            <Col>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Body>
                                        <Card.Text>
                                            <Steps current={step}>
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 0 ? "hidden-on-mobile" : ""}
                                                    title="ข้อมูลทั่วไป"
                                                    icon={
                                                        step === 0 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #039be5', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#039be5', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-person"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-person"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 1 ? "hidden-on-mobile" : ""}
                                                    title="การเรียน"
                                                    icon={
                                                        step === 1 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #ffb300', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#ffb300', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-mortarboard"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-mortarboard"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 2 ? "hidden-on-mobile" : ""}
                                                    title="ครอบครัว"
                                                    icon={
                                                        step === 2 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #ec407a', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#ec407a', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-people"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-people"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 3 ? "hidden-on-mobile" : ""}
                                                    title="กิจกรรม"
                                                    icon={
                                                        step === 3 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #673ab7', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#673ab7', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-palette"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-palette"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 4 ? "hidden-on-mobile" : ""}
                                                    title="ข้อมูลเฉพาะสิทธิ์"
                                                    icon={
                                                        step === 4 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #C0C0C0', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#C0C0C0', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-shield-check"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-shield-check"></i>
                                                        )
                                                    }
                                                />
                                                <Steps.Item
                                                    style={{ margin: '0.5em 0' }}
                                                    className={step !== 5 ? "hidden-on-mobile" : ""}
                                                    title="ติดตามข่าวสาร"
                                                    icon={
                                                        step === 5 ? (
                                                            <div style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                textAlign: 'center',
                                                                top: 0,
                                                                left: 0,
                                                                display: 'flex', // Using modern flexbox
                                                                alignItems: 'center',
                                                                justifyContent: 'center', // Center the icon horizontally
                                                                border: '1px solid #32CD32', // You can choose to keep one of the border styles
                                                                borderRadius: '50%',
                                                                backgroundColor: '#32CD32', // If you want to set a background color
                                                            }}>
                                                                <i style={{ fontSize: 20, color: 'white' }} className="bi bi-info-circle"></i>
                                                            </div>
                                                        ) : (
                                                            <i style={{ fontSize: 20 }} className="bi bi-info-circle"></i>
                                                        )
                                                    }
                                                />
                                            </Steps>
                                            <hr />
                                            {step === 0 && <Panel header={`ข้อมูลทั่วไปของผู้สมัคร`}>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>
                                                                สิทธิ์ในการสมัครคัดเลือกทุนการศึกษา{' '}
                                                                <span style={{ fontSize: '0.85em', color: '#666' }}>
                                                                    (สามารถใช้หลายสิทธิ์ได้ แต่ต้องมีข้อใดข้อหนึ่งจึงจะสมัครได้)
                                                                </span>
                                                                <span style={{ color: 'red' }}> *</span>
                                                            </label>
                                                            <CheckboxGroup
                                                                name="rights"
                                                                defaultValue={this.getRightsValue()}
                                                                onChange={value => this.setState({
                                                                    rights1: value.includes("rights1"),
                                                                    rights2: value.includes("rights2"),
                                                                    rights3: value.includes("rights3"),
                                                                    rights4: value.includes("rights4"),
                                                                })}
                                                            >
                                                                <Checkbox value="rights1">
                                                                    สิทธิ์ที่ 1 เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ
                                                                </Checkbox>
                                                                <Checkbox value="rights2">
                                                                    สิทธิ์ที่ 2 เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวง พระบรมราชูปถัมภ์
                                                                </Checkbox>
                                                                <Checkbox value="rights3">
                                                                    สิทธิ์ที่ 3 เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี
                                                                </Checkbox>
                                                                <Checkbox value="rights4">
                                                                    สิทธิ์ที่ 4 เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)
                                                                </Checkbox>
                                                            </CheckboxGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>

                                                <Divider />

                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <label>1. รูปถ่าย <span style={{ color: 'red' }}>*</span></label>
                                                            <Stack
                                                                className='cNlLu'
                                                                spacing={6}
                                                                direction={'column'}
                                                                alignItems={'flex-start'}
                                                            >
                                                                <Images
                                                                    className="border"
                                                                    src={this.state.croppedImage}
                                                                    rounded
                                                                    fluid
                                                                    width={142}
                                                                    height={198} />
                                                                <Button
                                                                    size='sm'
                                                                    color="green"
                                                                    appearance="primary"
                                                                    startIcon={<i class="bi bi-card-image"></i>}
                                                                    onClick={() => this.onSelectedImage()}>กรุณาเลือกรูปภาพ</Button>
                                                                <input
                                                                    id='InputImageUpload'
                                                                    type='file'
                                                                    accept='image/*'
                                                                    onChange={(e) => this.onSelectFile({ event: e, mode, step })}
                                                                    hidden />
                                                            </Stack>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. เลขบัตรประชาชน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='NG8dO'
                                                                size='sm'
                                                                value={this.state.id_card_number}
                                                                readOnly />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. คำนำหน้า <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='J8eC9'
                                                                size='lg'
                                                                data={[
                                                                    { value: 'นาย', label: 'นาย' },
                                                                    { value: 'นางสาว', label: 'นางสาว' }
                                                                ]}
                                                                defaultValue={this.state.prefix}
                                                                searchable={false}
                                                                style={{ width: 180 }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                onChange={e => this.setState({ prefix: e })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. ชื่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='A1bC3'
                                                                size='sm'
                                                                defaultValue={this.state.first_name}
                                                                onChange={e => this.setState({ first_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. ชื่อเล่น <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='IfAt8'
                                                                size='sm'
                                                                defaultValue={this.state.nickname}
                                                                onChange={e => this.setState({ nickname: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. นามสกุล <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='D4eF5'
                                                                size='sm'
                                                                defaultValue={this.state.last_name}
                                                                onChange={e => this.setState({ last_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. วัน/เดือน/ปี เกิด <span style={{ color: 'red' }}>*</span></label>
                                                            <div className='G6hI7' style={{ display: 'flex', alignItems: 'center' }}>
                                                                <ThaiDatePicker
                                                                    placeholder="วัน/เดือน/ปี พ.ศ."
                                                                    value={this.state.date_of_birth}
                                                                    inputProps={{
                                                                        style: {
                                                                            padding: '6px 8px',
                                                                            borderRadius: '6px 0 0 6px',
                                                                            border: '1px solid #E7E5E4',
                                                                            width: '200px',
                                                                        }
                                                                    }}
                                                                    onChange={async (e) => {
                                                                        await this.promisedSetState({ date_of_birth: e });
                                                                        this.onRenderContent({ mode, step });
                                                                    }}
                                                                    onClean={async () => {
                                                                        await this.promisedSetState({ date_of_birth: '' });
                                                                        this.onRenderContent({ mode, step });
                                                                    }}
                                                                />
                                                                <IconButton
                                                                    icon={<i className="bi bi-calendar3"></i>}
                                                                    size="md"
                                                                    style={{
                                                                        borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                                    }}
                                                                />
                                                            </div>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>
                                                                8. ชนเผ่า <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <SelectPicker
                                                                    className='J8kL9'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.ethnics}
                                                                    style={{ width: 224 }}
                                                                    value={this.state.ethnicity}
                                                                    onChange={async value => {
                                                                        await this.promisedSetState({ ethnicity: value })

                                                                        if (value !== 'other') {
                                                                            await this.promisedSetState({ ethnicity_other: '' })
                                                                        }

                                                                        await this.onRenderContent({ mode: mode, step: step })
                                                                    }}
                                                                    onClean={async () => {
                                                                        await this.promisedSetState({
                                                                            ethnicity: '',
                                                                            ethnicity_other: ''
                                                                        })
                                                                        await this.onRenderContent({ mode: mode, step: step })
                                                                    }}
                                                                    cleanable
                                                                />

                                                                {this.state.ethnicity === 'อื่นๆ' && (
                                                                    <Input
                                                                        className='B8xC4'
                                                                        size='sm'
                                                                        placeholder="โปรดระบุ"
                                                                        value={this.state.ethnicity_other || ''}
                                                                        onChange={async value => {
                                                                            await this.promisedSetState({ ethnicity_other: value })
                                                                            await this.onRenderContent({ mode: mode, step: step })
                                                                        }}
                                                                        style={{ width: 200 }}
                                                                    />
                                                                )}
                                                            </div>

                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <label className='mb-2'>9. ที่อยู่ตามทะเบียนบ้าน <span style={{ color: 'red' }}>*</span></label>
                                                    <Stack wrap spacing={10}>
                                                        <VStack>
                                                            <label>บ้านเลขที่</label>
                                                            <Input
                                                                className='M0nO1'
                                                                size='sm'
                                                                style={{ width: 90 }}
                                                                defaultValue={this.state.reg_house_number}
                                                                onChange={e => this.setState({ reg_house_number: e })} />
                                                        </VStack>
                                                        <VStack>
                                                            <label>หมู่ที่</label>
                                                            <Input
                                                                className='P2qR3'
                                                                size='sm'
                                                                style={{ width: 60 }}
                                                                defaultValue={this.state.reg_village_no}
                                                                onChange={e => this.setState({ reg_village_no: e })} />
                                                        </VStack>
                                                        <VStack>
                                                            <label>หมู่บ้าน</label>
                                                            <SelectPicker
                                                                className='S4tU5'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.villages}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_village}
                                                                onChange={async e => {
                                                                    await this.promisedSetState({ reg_village: e })
                                                                    await this.onRenderContent({ mode: mode, step: step })
                                                                }}
                                                            />
                                                        </VStack>
                                                        {this.state.reg_village === 'other' && (
                                                            <VStack>
                                                                <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                                <Input
                                                                    className='uw1NV'
                                                                    size='sm'
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.reg_village_name}
                                                                    onChange={e => this.setState({ reg_village_name: e })}
                                                                />
                                                            </VStack>
                                                        )}
                                                        <VStack>
                                                            <label>จังหวัด</label>
                                                            <SelectPicker
                                                                className='V6wX7'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_province_selection}
                                                                style={{ width: 200 }}
                                                                value={this.state.reg_province_id}
                                                                onSelect={async (v, i) => {
                                                                    await this.promisedSetState({ reg_province: i.label, reg_province_id: i.value })
                                                                    await this.handleProvinceChange({
                                                                        value: i.value,
                                                                        mode: 'read',
                                                                        step: step,
                                                                        amphureKey: 'reg_amphur_selection',
                                                                        tambonKey: 'reg_tambon_selection'
                                                                    })
                                                                }}
                                                            />
                                                        </VStack>
                                                        <VStack>
                                                            <label>อำเภอ</label>
                                                            <SelectPicker
                                                                className='Y8zA9'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_amphur_selection}
                                                                style={{ width: 200 }}
                                                                value={this.state.reg_amphur_id}
                                                                onSelect={async (v, i) => {
                                                                    await this.promisedSetState({ reg_amphur: i.label, reg_amphur_id: i.value })
                                                                    await this.handleAmphureChange({
                                                                        value: i.value,
                                                                        mode: 'read',
                                                                        step: step,
                                                                        tambonKey: 'reg_tambon_selection'
                                                                    })
                                                                }}
                                                            />
                                                        </VStack>
                                                        <VStack>
                                                            <label>ตำบล</label>
                                                            <SelectPicker
                                                                className='B0cD1'
                                                                size='lg'
                                                                placeholder='กรุณาเลือก'
                                                                data={this.state.reg_tambon_selection}
                                                                style={{ width: 200 }}
                                                                defaultValue={this.state.reg_tambon_id}
                                                                onSelect={async (v, i) => await this.promisedSetState({ reg_tambon: i.label, reg_tambon_id: i.value })} />
                                                        </VStack>
                                                    </Stack>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>10. ที่อยู่จริงในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup
                                                                className='E2fG3'
                                                                name="is_reg_address"
                                                                defaultValue={this.state.is_reg_address}
                                                                onChange={async e => {
                                                                    await this.promisedSetState({ is_reg_address: e })
                                                                    await this.onRenderContent({ mode: mode, step: step })
                                                                }}
                                                            >
                                                                <Radio value="yes">อาศัยอยู่ตามที่อยู่ในทะเบียนบ้าน</Radio>
                                                                <Radio value="no">ไม่ได้อาศัยอยู่ตามทะเบียนบ้าน</Radio>
                                                            </RadioGroup>

                                                            {this.state.is_reg_address === 'no' && (
                                                                <div className="mt-2">
                                                                    <Stack wrap spacing={10}>
                                                                        <VStack>
                                                                            <label>บ้านเลขที่</label>
                                                                            <Input
                                                                                className='H4iJ5'
                                                                                size='sm'
                                                                                style={{ width: 90 }}
                                                                                defaultValue={this.state.temp_house_number}
                                                                                onChange={e => this.setState({ temp_house_number: e })} />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>หมู่ที่</label>
                                                                            <Input
                                                                                className='K6lM7'
                                                                                size='sm'
                                                                                style={{ width: 60 }}
                                                                                defaultValue={this.state.temp_village_no}
                                                                                onChange={e => this.setState({ temp_village_no: e })} />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>หมู่บ้าน</label>
                                                                            <SelectPicker
                                                                                className='N8oP9'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.villages}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_village}
                                                                                onChange={async e => {
                                                                                    await this.promisedSetState({ temp_village: e })
                                                                                    await this.onRenderContent({ mode: mode, step: step })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        {this.state.temp_village === 'other' && (
                                                                            <VStack>
                                                                                <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                                                <Input
                                                                                    className='O1aj5'
                                                                                    size='sm'
                                                                                    style={{ width: 200 }}
                                                                                    defaultValue={this.state.temp_village_name}
                                                                                    onChange={e => this.setState({ temp_village_name: e })}
                                                                                />
                                                                            </VStack>
                                                                        )}

                                                                        <VStack>
                                                                            <label>จังหวัด</label>
                                                                            <SelectPicker
                                                                                className='Q0rS1'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_province_selection}
                                                                                style={{ width: 200 }}
                                                                                value={this.state.temp_province_id}
                                                                                onSelect={async (v, i) => {
                                                                                    await this.promisedSetState({ temp_province: i.label, temp_province_id: i.value })
                                                                                    await this.handleProvinceChange({
                                                                                        value: i.value,
                                                                                        mode: 'read',
                                                                                        step: step,
                                                                                        amphureKey: 'temp_amphur_selection',
                                                                                        tambonKey: 'temp_tambon_selection'
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>อำเภอ</label>
                                                                            <SelectPicker
                                                                                className='T2uV3'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_amphur_selection}
                                                                                style={{ width: 200 }}
                                                                                value={this.state.temp_amphur_id}
                                                                                onSelect={async (v, i) => {
                                                                                    await this.promisedSetState({ temp_amphur: i.label, temp_amphur_id: i.value })
                                                                                    await this.handleAmphureChange({
                                                                                        value: i.value,
                                                                                        mode: 'read',
                                                                                        step: step,
                                                                                        tambonKey: 'temp_tambon_selection'
                                                                                    })
                                                                                }}
                                                                            />
                                                                        </VStack>
                                                                        <VStack>
                                                                            <label>ตำบล</label>
                                                                            <SelectPicker
                                                                                className='W4xY5'
                                                                                size='lg'
                                                                                placeholder='กรุณาเลือก'
                                                                                data={this.state.temp_tambon_selection}
                                                                                style={{ width: 200 }}
                                                                                defaultValue={this.state.temp_tambon_id}
                                                                                onSelect={async (v, i) => await this.promisedSetState({ temp_tambon: i.label, temp_tambon_id: i.value })} />
                                                                        </VStack>
                                                                    </Stack>
                                                                </div>
                                                            )}
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>11. เบอร์โทรศัพท์ติดต่อส่วนตัวของผู้สมัครขอรับทุน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='Z6aB7'
                                                                size='sm'
                                                                defaultValue={this.state.phone}
                                                                onChange={e => this.setState({ phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>12. ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='C8dE9'
                                                                name="is_family_residence"
                                                                defaultValue={this.state.is_family_residence}
                                                                onChange={e => this.setState({ is_family_residence: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='F0gH1'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='I2jK3'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='L4mN5'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_residence_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_residence_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>13. ที่ทำกินของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='O6pQ7'
                                                                name="is_family_work"
                                                                defaultValue={this.state.is_family_work}
                                                                onChange={e => this.setState({ is_family_work: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีที่ทำกินเป็นของครอบครัว</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='R8sT9'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='U0vW1'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='X2yZ3'
                                                                            size='lg'
                                                                            defaultValue={this.state.family_work_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ family_work_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีที่ทำกินของครอบครัว</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>14. ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='FMtwT'
                                                                name="is_none_residence"
                                                                defaultValue={this.state.is_none_residence}
                                                                onChange={e => this.setState({ is_none_residence: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='9CWlD'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='f3HUH'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='oNLEh'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_residence_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_residence_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <VStack>
                                                            <span>15. ที่ทำกินนอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                            <RadioGroup
                                                                className='wcyIb'
                                                                name="is_none_work"
                                                                defaultValue={this.state.is_none_work}
                                                                onChange={e => this.setState({ is_none_work: e })} >
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="yes">มีที่ทำกินนอกพื้นที่</Radio>
                                                                    <HStack>
                                                                        <span>จำนวน</span>
                                                                        <InputNumber
                                                                            className='gljzF'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_rai}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_rai: e })} />
                                                                        <span>ไร่</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='O12si'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_ngan}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_ngan: e })} />
                                                                        <span>งาน</span>
                                                                    </HStack>

                                                                    <HStack>
                                                                        <InputNumber
                                                                            className='5CFWy'
                                                                            size='lg'
                                                                            defaultValue={this.state.none_work_wah}
                                                                            min={0}
                                                                            style={{ width: 80 }}
                                                                            onChange={e => this.setState({ none_work_wah: e })} />
                                                                        <span>ตารางวา</span>
                                                                    </HStack>
                                                                </Stack>
                                                                <Stack wrap spacing={6}>
                                                                    <Radio value="no">ไม่มีที่ทำกินนอกพื้นที่</Radio>
                                                                </Stack>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 1 && <Panel header={`ข้อมูลการเรียนของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <Stack wrap spacing={6}>
                                                            <label>1. ระดับการศึกษาที่ศึกษาอยู่ <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='6RSoG'
                                                                size='lg'
                                                                data={[
                                                                    { value: 'มัธยมศึกษาปีที่ 6', label: 'มัธยมศึกษาปีที่ 6' },
                                                                    { value: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3', label: 'ประกาศนียบัตรวิชาชีพ (ปวช.) ปีที่ 3' },
                                                                    { value: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2', label: 'ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.) ปีที่ 2' },
                                                                ]}
                                                                searchable={false}
                                                                style={{ width: 300 }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                defaultValue={this.state.edu_level}
                                                                onChange={e => this.setState({ edu_level: e })}
                                                            />
                                                        </Stack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. สถานศึกษา ณ ปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='hkpCS'
                                                                size='sm'
                                                                defaultValue={this.state.curr_institution}
                                                                onChange={e => this.setState({ curr_institution: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. สาย/สาขาที่เรียนในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='ptwhS'
                                                                size='sm'
                                                                defaultValue={this.state.curr_field}
                                                                onChange={e => this.setState({ curr_field: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. ผลการเรียน GPAX <span style={{ color: 'red' }}>*</span></label>
                                                            <InputNumber
                                                                className='Jqmmy'
                                                                size='lg'
                                                                defaultValue={this.state.grades}
                                                                min={0}
                                                                style={{ width: 160 }}
                                                                onChange={e => this.setState({ grades: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. สถานศึกษาที่จะเรียนต่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <SelectPicker
                                                                className='1Pxg2'
                                                                size='lg'
                                                                data={this.state.schools}
                                                                style={{ width: '100%' }}
                                                                placeholder="กรุณาเลือกรายการ"
                                                                defaultValue={this.state.next_institution}
                                                                onChange={e => this.setState({ next_institution: e })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. สาย/สาขาที่จะเรียนต่อ <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='coZ10'
                                                                size='sm'
                                                                defaultValue={this.state.next_field}
                                                                onChange={e => this.setState({ next_field: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. สถานะการสมัครเรียนในมหาวิทยาลัย <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup
                                                                className='nYC39'
                                                                name="app_status"
                                                                defaultValue={this.state.app_status}
                                                                onChange={e => this.setState({ app_status: e })}>
                                                                <Radio value="สอบติดเรียบร้อยและยืนยันการเข้าเรียน">สอบติดเรียบร้อยและยืนยันการเข้าเรียน</Radio>
                                                                <Radio value="สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน">สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน</Radio>
                                                                <Radio value="รอผลประกาศการสอบเข้า">รอผลประกาศการสอบเข้า</Radio>
                                                                <Radio value="ยังไม่ได้ดำเนินการสอบ">ยังไม่ได้ดำเนินการสอบ</Radio>
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 2 && <Panel header={`ข้อมูลครอบครัวของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <label>1. ชื่อ-นามสกุล บิดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='lvPX0'
                                                                size='sm'
                                                                defaultValue={this.state.father_full_name}
                                                                onChange={e => this.setState({ father_full_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>2. อายุบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <InputNumber
                                                                className='Z2nR8'
                                                                size='lg'
                                                                defaultValue={this.state.father_age}
                                                                onChange={e => this.setState({ father_age: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>3. อาชีพของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='7bbc3'
                                                                size='sm'
                                                                defaultValue={this.state.father_occupation}
                                                                onChange={e => this.setState({ father_occupation: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>4. สถานที่ทำงานของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='5Glbw'
                                                                size='sm'
                                                                defaultValue={this.state.father_workplace}
                                                                onChange={e => this.setState({ father_workplace: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>5. หมายเลขโทรศัพท์ของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='F4SVQ'
                                                                size='sm'
                                                                defaultValue={this.state.father_phone}
                                                                onChange={e => this.setState({ father_phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>6. ชื่อ-นามสกุล มารดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='iKyhX'
                                                                size='sm'
                                                                defaultValue={this.state.mother_full_name}
                                                                onChange={e => this.setState({ mother_full_name: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>7. อายุมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <InputNumber
                                                                className='IBNHp'
                                                                size='lg'
                                                                defaultValue={this.state.mother_age}
                                                                onChange={e => this.setState({ mother_age: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>8. อาชีพของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='cLyOx'
                                                                size='sm'
                                                                defaultValue={this.state.mother_occupation}
                                                                onChange={e => this.setState({ mother_occupation: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>9. สถานที่ทำงานมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='a5lO7'
                                                                size='sm'
                                                                defaultValue={this.state.mother_workplace}
                                                                onChange={e => this.setState({ mother_workplace: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>10. หมายเลขโทรศัพท์ของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <Input
                                                                className='v2vfN'
                                                                size='sm'
                                                                defaultValue={this.state.mother_phone}
                                                                onChange={e => this.setState({ mother_phone: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>11. สถานะของบิดา มารดา <span style={{ color: 'red' }}>*</span></label>
                                                            <RadioGroup name="parent_status"
                                                                defaultValue={this.state.parent_status}
                                                                onChange={e => this.setState({ parent_status: e })} >
                                                                <Radio value="บิดา มารดาอยู่ด้วยกัน">บิดา มารดาอยู่ด้วยกัน</Radio>
                                                                <Radio value="เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ">เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='dwURj'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_1}
                                                                    onChange={e => this.setState({ parent_status_1: e })} />
                                                                <Radio value="บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ">บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='Go2la'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_2}
                                                                    onChange={e => this.setState({ parent_status_2: e })} />
                                                                <Radio value="บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ">บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ</Radio>
                                                                <Input
                                                                    className='VoUBJ'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_3}
                                                                    onChange={e => this.setState({ parent_status_3: e })} />
                                                                <Radio value="อื่นๆ โปรดระบุ">อื่นๆ โปรดระบุ</Radio>
                                                                <Input
                                                                    className='W0HZe'
                                                                    size='sm'
                                                                    defaultValue={this.state.parent_status_4}
                                                                    onChange={e => this.setState({ parent_status_4: e })} />
                                                            </RadioGroup>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <Stack wrap spacing={6}>
                                                            <span>12. ผู้ปกครองที่สามารถติดต่อได้ <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='wYDAd'
                                                                size='sm'
                                                                style={{ width: 220 }}
                                                                defaultValue={this.state.contactable}
                                                                onChange={e => this.setState({ contactable: e })} />
                                                            <span>ความเกี่ยวข้องกับผู้สมัคร <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='tgWgt'
                                                                size='sm'
                                                                style={{ width: 220 }}
                                                                defaultValue={this.state.relationship_to_applicant}
                                                                onChange={e => this.setState({ relationship_to_applicant: e })} />
                                                        </Stack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>13. จำนวนพี่น้องร่วมบิดามารดา (ไม่รวมผู้สมัคร) <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='M7j9Z'
                                                                size='lg'
                                                                defaultValue={this.state.total_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ total_siblings: e })} />
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>14. จำนวนพี่น้องที่ทำงานแล้ว <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='L1f3r'
                                                                size='lg'
                                                                defaultValue={this.state.working_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ working_siblings: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>15. จำนวนพี่น้องที่เรียนอยู่ <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='RxG98'
                                                                size='lg'
                                                                defaultValue={this.state.siblings_in_school}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ siblings_in_school: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>16. จำนวนพี่น้องที่ว่างงาน <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='VM5Wt'
                                                                size='lg'
                                                                defaultValue={this.state.unemployed_siblings}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ unemployed_siblings: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mt-3'>
                                                        <HStack>
                                                            <span>17. จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน <span style={{ color: 'red' }}>*</span></span>
                                                            <InputNumber
                                                                className='CczEW'
                                                                size='lg'
                                                                defaultValue={this.state.siblings_not_of_age}
                                                                max={20}
                                                                min={0}
                                                                style={{ width: 60 }}
                                                                onChange={e => this.setState({ siblings_not_of_age: e })} />
                                                            <span>คน</span>
                                                        </HStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <label>18. รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว) <span style={{ color: 'red' }}>*</span></label>
                                                            <HStack>
                                                                <InputNumber
                                                                    className='oCbgK'
                                                                    size='lg'
                                                                    defaultValue={this.state.family_income_per_year}
                                                                    min={0}
                                                                    formatter={this.to2decimal}
                                                                    style={{ width: 180 }}
                                                                    onChange={e => this.setState({ family_income_per_year: e })} />
                                                                <span>บาท/ปี</span>
                                                            </HStack>
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <label>19. ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร <span style={{ color: 'red' }}>*</span></label>
                                                        <VStack className='mt-2'>
                                                            <span>ชื่อ-นามสกุล</span>
                                                            <Input
                                                                className='O54dB'
                                                                size='sm'
                                                                defaultValue={this.state.provider_full_name}
                                                                onChange={e => this.setState({ provider_full_name: e })} />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>ความเกี่ยวข้องกับผู้สมัคร</span>
                                                            <Input
                                                                className='K3ax9'
                                                                size='sm'
                                                                defaultValue={this.state.provider_relationship}
                                                                onChange={e => this.setState({ provider_relationship: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 3 && <Panel header={`ข้อมูลการเข้าร่วมกิจกรรมของผู้สมัคร`}>
                                                <Row>
                                                    <Col>
                                                        <VStack>
                                                            <span>1. กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์/โครงการดอยตุงฯ <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='I2xNI'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.doitung_activities}
                                                                onChange={e => this.setState({ doitung_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <span>2. กิจกรรมที่เคยเข้าร่วมของโรงเรียน <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='12oqZ'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.school_activities}
                                                                onChange={e => this.setState({ school_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                                <Row className='mt-3'>
                                                    <Col>
                                                        <VStack>
                                                            <span>3. กิจกรรมที่อื่นๆ ที่เคยเข้าร่วม <span style={{ color: 'red' }}>*</span></span>
                                                            <Input
                                                                className='bRS7p'
                                                                as="textarea"
                                                                rows={3}
                                                                defaultValue={this.state.other_activities}
                                                                onChange={e => this.setState({ other_activities: e })} />
                                                        </VStack>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            {step === 4 && <Panel header={`ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์`}>
                                                {this.state.rights1 === true && <Row className='mb-3'>
                                                    <Col>
                                                        <span>สิทธิ์ที่ 1 เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ <span style={{ color: 'red' }}>*</span></span>
                                                        <VStack className='mt-2'>
                                                            <span>1. เลข คพต.พ ของผู้สมัคร</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='9J7pS mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.applicant_proj_no}
                                                                onChange={e => this.setState({ applicant_proj_no: e })}
                                                            />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>2. เลข คพต.พ ของบิดา</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='RGucO mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.father_proj_no}
                                                                onChange={e => this.setState({ father_proj_no: e })}
                                                            />
                                                        </VStack>
                                                        <VStack className='mt-2'>
                                                            <span>3. เลข คพต.พ ของมารดา</span>
                                                            <MaskedInput
                                                                size='sm'
                                                                className='GXywQ mt-2'
                                                                mask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /[1-9]/, // First digit (1-9)
                                                                    '-',
                                                                    /\d/, /\d/, // Two digits (00-99)
                                                                    '-',
                                                                    /\d/, /\d/, /\d/, /\d/, // Four digits (0000-9999)
                                                                ]}
                                                                guide={true}
                                                                showMask={[
                                                                    'ค', 'พ', 'ต', '.', 'พ', ' ',
                                                                    /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
                                                                ]}
                                                                keepCharPositions={true}
                                                                style={{ letterSpacing: '0.05em' }}
                                                                placeholderChar={'_'}
                                                                defaultValue={this.state.mother_proj_no}
                                                                onChange={e => this.setState({ mother_proj_no: e })}
                                                            />
                                                        </VStack>
                                                    </Col>
                                                </Row>}
                                                {this.state.rights4 === true && <Row>
                                                    <Col>
                                                        <span>สิทธิ์ที่ 4 เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน) <span style={{ color: 'red' }}>*</span></span>
                                                        <Text muted>รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ</Text>
                                                        <Row>
                                                            <Col>
                                                                <Checkbox value="father_rights4"
                                                                    defaultChecked={this.state.father_rights4}
                                                                    onChange={async (e, v) => {
                                                                        await this.promisedSetState({ father_rights4: v })
                                                                    }}>บิดา</Checkbox>
                                                                <Row style={{ marginLeft: 25 }}>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>รหัสพนักงาน</span>
                                                                            <Input
                                                                                className='YMsqu'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_no}
                                                                                onChange={e => this.setState({ rights_father_no: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ตำแหน่งงาน</span>
                                                                            <Input
                                                                                className='j1YSQ'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_job_title}
                                                                                onChange={e => this.setState({ rights_father_job_title: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ส่วนงาน/แผนก</span>
                                                                            <Input
                                                                                className='MoUaX'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_father_department}
                                                                                onChange={e => this.setState({ rights_father_department: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>จำนวนปีที่ทำงานในมูลนิธิฯ</span>
                                                                            <HStack>
                                                                                <InputNumber
                                                                                    className='Fr7KT'
                                                                                    size='lg'
                                                                                    defaultValue={this.state.rights_father_years}
                                                                                    min={0}
                                                                                    style={{ width: 80 }}
                                                                                    onChange={e => this.setState({ rights_father_years: e })} />
                                                                                <span>ปี</span>
                                                                            </HStack>
                                                                        </VStack>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Checkbox value="mother_rights4"
                                                                    defaultChecked={this.state.mother_rights4}
                                                                    onChange={(e, v) => this.setState({ mother_rights4: v })}>มารดา</Checkbox>
                                                                <Row style={{ marginLeft: 25 }}>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>รหัสพนักงาน</span>
                                                                            <Input
                                                                                className='Bu8fI'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_no}
                                                                                onChange={e => this.setState({ rights_mother_no: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ตำแหน่งงาน</span>
                                                                            <Input
                                                                                className='gKKkV'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_job_title}
                                                                                onChange={e => this.setState({ rights_mother_job_title: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>ส่วนงาน/แผนก</span>
                                                                            <Input
                                                                                className='1BgFc'
                                                                                size='sm'
                                                                                style={{ width: 180 }}
                                                                                defaultValue={this.state.rights_mother_department}
                                                                                onChange={e => this.setState({ rights_mother_department: e })} />
                                                                        </VStack>
                                                                    </Col>
                                                                    <Col xs={12} lg={3} className='mb-2'>
                                                                        <VStack>
                                                                            <span>จำนวนปีที่ทำงานในมูลนิธิฯ</span>
                                                                            <HStack>
                                                                                <InputNumber
                                                                                    className='A5AP8'
                                                                                    size='lg'
                                                                                    defaultValue={this.state.rights_mother_years}
                                                                                    min={0}
                                                                                    style={{ width: 80 }}
                                                                                    onChange={e => this.setState({ rights_mother_years: e })} />
                                                                                <span>ปี</span>
                                                                            </HStack>
                                                                        </VStack>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>}
                                                {this.state.rights1 === false && this.state.rights4 === false &&
                                                    <Row>
                                                        <Col><Text>ไม่มี (กรุณาทำรายการถัดไป)</Text></Col>
                                                    </Row>
                                                }
                                            </Panel>}
                                            {step === 5 && <Panel>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <img src={QRcode} style={{ width: '50%', borderRadius: '8px' }} alt="Line" />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                            <Text weight='bold'>ขอความร่วมมือทุกคนเข้ากลุ่มไลน์</Text>
                                                            <Text>เพื่อติดตามข่าวสารการสัมภาษณ์ ติดตามผลการคัดเลือกทุน และติดตามเรื่องการส่งเอกสารเพิ่มเติม หากเข้ากลุ่มแล้วจะขอให้นักเรียนแนะนำตัวเองด้วย ชื่อ นามสกุล ชื่อเล่น สาขาและสถาบันที่จะไปเรียนต่อ หรือหากติดปัญหาระหว่างการเข้ากลุ่ม ติดต่อเจ้าหน้าที่ได้ที่เบอร์ 0827581119 พี่หยุม</Text>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                            <Checkbox defaultChecked={true} readOnly>
                                                                <Text weight='bold' color='green'>เข้ากลุ่ม Line เรียบร้อยแล้ว</Text>
                                                            </Checkbox>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Panel>}
                                            <hr />
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                    startIcon={<i className="bi bi-chevron-left"></i>}
                                                    onClick={() => this.onPrevious(step)}
                                                    disabled={step === 0}
                                                    style={{ marginRight: '0.5em' }}
                                                >
                                                    ย้อนกลับ
                                                </Button>

                                                {step === 5 ? (
                                                    <Button
                                                        color={this.state.existing ? 'yellow' : 'green'}
                                                        appearance="primary"
                                                        startIcon={this.state.existing ? <i class="bi bi-pencil-square"></i> : <i className="bi bi-send-fill"></i>}
                                                        disabled={!this.state.is_linegroup}
                                                        onClick={() => this.onNext({ step, existing: this.state.existing })}
                                                    >
                                                        {this.state.existing ? 'แก้ไขข้อมูล' : 'ส่งข้อมูล'}
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        appearance="primary"
                                                        endIcon={<i className="bi bi-chevron-right"></i>}
                                                        onClick={() => this.onNext({ step })}
                                                        disabled={step === 5} // Disable if step is 5 to avoid conflicts
                                                    >
                                                        ถัดไป
                                                    </Button>
                                                )}
                                            </div>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <br />
                    </>
                )
            });

            await this.promisedSetState({ loading: false })
        }
    }

    onSelectedImage = () => {
        const input = document.getElementById('InputImageUpload');
        if (input) {
            input.click(); // Trigger the file input click
        }
    }

    // Crop Image
    onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedAreaPixels });
    };

    onSelectFile = async ({ event, mode, step }) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = async () => {
                await this.promisedSetState({ image: reader.result });
                await this.onModal({ mode: 'read', step })
            };
        }
    };

    createImage = (url) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = (error) => reject(error);
            image.crossOrigin = "anonymous"; // Handle cross-origin issues
            image.src = url;
        });
    };

    getRadianAngle(degreeValue) {
        return (degreeValue * Math.PI) / 180;
    }

    getBase64 = async (imageSrc, pixelCrop, rotation) => {
        const image = await this.createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxSize = Math.max(image.width, image.height);
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

        canvas.width = safeArea;
        canvas.height = safeArea;

        ctx.translate(safeArea / 2, safeArea / 2);
        ctx.rotate(this.getRadianAngle(rotation));
        ctx.translate(-safeArea / 2, -safeArea / 2);

        ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);

        const data = ctx.getImageData(0, 0, safeArea, safeArea);

        // Adjust canvas to cropped area size
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.putImageData(
            data,
            0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x,
            0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y
        );

        return canvas.toDataURL("image/jpeg");
    };

    base64ToBlob(base64String, contentType = '') {
        const byteCharacters = atob(base64String);
        const byteArrays = [];

        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }

        const byteArray = new Uint8Array(byteArrays);
        return new Blob([byteArray], { type: contentType });
    }

    onModal = async ({ mode, step }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                modal: <Modal size='md' open={true} onClose={() => this.setState({ modal: null })}>
                    <Modal.Body>
                        <div style={{ width: '100%', height: '600px' }}>
                            <Cropper
                                image={this.state.image}
                                crop={this.state.crop}
                                zoom={this.state.zoom}
                                aspect={0.8 / 1}
                                onCropChange={async (e) => {
                                    await this.promisedSetState({ crop: e })
                                    await this.onModal({ mode, step })
                                }}
                                onZoomChange={async (e) => {
                                    await this.promisedSetState({ zoom: e })
                                    await this.onModal({ mode, step })
                                }}
                                onCropComplete={async (p, a) => {
                                    await this.promisedSetState({ croppedArea: a });
                                    await this.onModal({ mode, step })
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className='p-2'>
                        <Button
                            onClick={async () => {
                                await this.promisedSetState({ loading: true }); // Set loading state to true
                                const croppedImage = await this.getBase64(this.state.image, this.state.croppedArea, 0);
                                await this.promisedSetState({ croppedImage });
                                await this.promisedSetState({ modal: null })
                                await this.onRenderContent({ mode: mode, step: step })
                                await this.promisedSetState({ loading: false }); // Reset loading state
                            }}
                            appearance="primary"
                            startIcon={<i className="bi bi-check2-square"></i>}>
                            ยืนยัน
                        </Button>
                        <Button
                            onClick={() => this.setState({ modal: null })}
                            appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })
        }
    }

    fetchSchools = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/schools`, this.state.authHeader);
            const data = response.data.map(school => ({
                label: school.name, // Label for the dropdown
                value: school.name    // Value for the selection
            }));

            // Add "อื่นๆ" as the last option
            data.push({
                label: 'อื่นๆ',  // Label for the "Others" option
                value: 'อื่นๆ'   // Value for the "Others" option
            });

            await this.promisedSetState({ schools: data });
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    };

    fetchEthnics = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/ethnics`, this.state.authHeader);
            const data = response.data.map(ethnic => ({
                label: ethnic.name, // Display name in the dropdown
                value: ethnic.name    // Value for the selection
            }));
            await this.promisedSetState({ ethnics: data });
        } catch (error) {
            console.error("Error fetching ethnics:", error);
        }
    };

    fetchVillages = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/villages`, this.state.authHeader);
            const data = response.data.map(village => ({
                label: village.name, // Display name in the dropdown
                value: village.name    // Value for the selection
            }));

            // Add the "Other" option at the end of the list
            data.push({
                label: 'อื่นๆ (โปรดระบุ)',
                value: 'other'  // The value for the "Other" option
            });

            // Update the state with the villages data
            await this.promisedSetState({ villages: data });
        } catch (error) {
            console.error("Error fetching villages:", error);
        }
    };

    fetchProvinces = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/provinces`, this.state.authHeader);
            const provinces = response.data.map(province => ({
                label: province.name_th,
                value: province.id
            }));

            await this.promisedSetState({ reg_province_selection: provinces, temp_province_selection: provinces });

        } catch (error) {
            console.error('Error fetching provinces:', error);
        }
    };

    fetchAmphures = async (amphureKey, tambonKey, provinceId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/amphures/${provinceId}`, this.state.authHeader);
            const amphuresData = response.data.map(amphure => ({
                label: amphure.name_th,
                value: amphure.id
            }));
            await this.promisedSetState({ [amphureKey]: amphuresData, [tambonKey]: [] }); // Reset tambons
        } catch (error) {
            console.error('Error fetching amphures:', error);
        }
    };

    fetchTambons = async (tambonKey, amphureId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/tambons/${amphureId}`, this.state.authHeader);
            const tambonsData = response.data.map(tambon => ({
                label: tambon.name_th,
                value: tambon.id
            }));
            await this.promisedSetState({ [tambonKey]: tambonsData });
        } catch (error) {
            console.error('Error fetching tambons:', error);
        }
    };

    handleProvinceChange = async ({ value, mode, step, amphureKey, tambonKey }) => {
        try {
            await this.fetchAmphures(amphureKey, tambonKey, value);
            await this.onRenderContent({ mode, step });
        } catch (error) {
            console.error('Error handling province change:', error);
        }
    };

    handleAmphureChange = async ({ value, mode, step, tambonKey }) => {
        try {
            await this.fetchTambons(tambonKey, value);
            await this.onRenderContent({ mode, step });
        } catch (error) {
            console.error('Error handling amphure change:', error);
        }
    };

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params === cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params !== cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onNext = async ({ step, existing }) => {

        const validateStep0 = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.croppedImage, 'cNlLu', ImageSize),
                this.Validate(this.state.id_card_number, 'NG8dO', ''),
                this.Validate(this.state.prefix, 'J8eC9', ''),
                this.Validate(this.state.first_name, 'A1bC3', ''),
                this.Validate(this.state.last_name, 'D4eF5', ''),
                this.Validate(this.state.nickname, 'IfAt8', ''),
                this.Validate(this.state.date_of_birth, 'G6hI7', ''),
                this.Validate(this.state.ethnicity, 'J8kL9', ''),
                ...(this.state.ethnicity === 'อื่นๆ' ? [
                    this.Validate(this.state.ethnicity_other, 'B8xC4', ''),
                ] : []),
                this.Validate(this.state.reg_house_number, 'M0nO1', ''),
                this.Validate(this.state.reg_village_no, 'P2qR3', ''),
                this.Validate(this.state.reg_village, 'S4tU5', ''),
                this.Validate(this.state.reg_province, 'V6wX7', ''),
                this.Validate(this.state.reg_amphur, 'Y8zA9', ''),
                this.Validate(this.state.reg_tambon, 'B0cD1', ''),
                this.Validate(this.state.family_residence_rai, 'F0gH1', ''),
                this.Validate(this.state.family_residence_ngan, 'I2jK3', ''),
                this.Validate(this.state.family_residence_wah, 'L4mN5', ''),
                this.Validate(this.state.family_work_rai, 'R8sT9', ''),
                this.Validate(this.state.family_work_ngan, 'U0vW1', ''),
                this.Validate(this.state.family_work_wah, 'X2yZ3', ''),

                // Conditionally add 'reg_village_name' if 'reg_village' is 'other'
                ...(this.state.reg_village === 'other' ? [
                    this.Validate(this.state.reg_village_name, 'uw1NV', ''),
                ] : []),

                // Conditionally add temporary address validations if applicable
                ...(this.state.is_reg_address === 'no' ? [
                    this.Validate(this.state.temp_house_number, 'H4iJ5', ''),
                    this.Validate(this.state.temp_village_no, 'K6lM7', ''),
                    this.Validate(this.state.temp_village, 'N8oP9', ''),
                    ...(this.state.temp_village === 'other' ? [
                        this.Validate(this.state.temp_village_name, 'O1aj5', ''),
                    ] : []),
                    this.Validate(this.state.temp_province, 'Q0rS1', ''),
                    this.Validate(this.state.temp_amphur, 'T2uV3', ''),
                    this.Validate(this.state.temp_tambon, 'W4xY5', '')
                ] : []),

                // Validate phone number
                this.Validate(this.state.phone, 'Z6aB7', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep1 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.edu_level, '6RSoG', ''),
                this.Validate(this.state.curr_institution, 'hkpCS', ''),
                this.Validate(this.state.curr_field, 'ptwhS', ''),
                this.Validate(this.state.grades, 'Jqmmy', ''),
                this.Validate(this.state.next_institution, '1Pxg2', ''),
                this.Validate(this.state.next_field, 'coZ10', ''),
                this.Validate(this.state.app_status, 'nYC39', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep2 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.father_full_name, 'lvPX0', ''),
                this.Validate(this.state.father_age, 'Z2nR8', ''),
                this.Validate(this.state.father_occupation, '7bbc3', ''),
                this.Validate(this.state.father_workplace, '5Glbw', ''),
                this.Validate(this.state.father_phone, 'F4SVQ', ''),
                this.Validate(this.state.mother_full_name, 'iKyhX', ''),
                this.Validate(this.state.mother_age, 'IBNHp', ''),
                this.Validate(this.state.mother_occupation, 'cLyOx', ''),
                this.Validate(this.state.mother_workplace, 'a5lO7', ''),
                this.Validate(this.state.mother_phone, 'v2vfN', ''),
                this.Validate(this.state.parent_status, 'TAzlS', ''),
                // Conditionally add temporary address validation if applicable
                ...(this.state.parent_status === 'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_1, 'dwURj', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_2, 'Go2la', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_3, 'VoUBJ', ''),
                ] : []),
                ...(this.state.parent_status === 'อื่นๆ โปรดระบุ' ? [
                    this.Validate(this.state.parent_status_4, 'W0HZe', ''),
                ] : []),
                this.Validate(this.state.contactable, 'wYDAd', ''),
                this.Validate(this.state.relationship_to_applicant, 'tgWgt', ''),
                this.Validate(this.state.provider_full_name, 'O54dB', ''),
                this.Validate(this.state.provider_relationship, 'K3ax9', ''),
                this.Validate(this.state.total_siblings, 'M7j9Z', ''),
                this.Validate(this.state.working_siblings, 'L1f3r', ''),
                this.Validate(this.state.siblings_in_school, 'RxG98', ''),
                this.Validate(this.state.unemployed_siblings, 'VM5Wt', ''),
                this.Validate(this.state.siblings_not_of_age, 'CczEW', ''),
                this.Validate(this.state.family_income_per_year, 'oCbgK', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep3 = async () => {
            // Start with an array of validations
            const validationPromises = [
                this.Validate(this.state.doitung_activities, 'I2xNI', ''),
                this.Validate(this.state.school_activities, '12oqZ', ''),
                this.Validate(this.state.other_activities, 'bRS7p', '')
            ];


            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        const validateStep4 = async () => {
            // Start with an array of validations
            const validationPromises = [
                // Conditionally add temporary address validation if applicable
                ...(this.state.rights1 === true ? [
                    this.Validate(this.state.applicant_proj_no, '9J7pS', ''),
                    this.Validate(this.state.father_proj_no, 'RGucO', ''),
                    this.Validate(this.state.mother_proj_no, 'GXywQ', ''),
                ] : []),
                ...(this.state.rights4 === true ? [
                    ...(this.state.father_rights4 === true ? [
                        this.Validate(this.state.rights_father_no, 'YMsqu', ''),
                        this.Validate(this.state.rights_father_job_title, 'j1YSQ', ''),
                        this.Validate(this.state.rights_father_department, 'MoUaX', ''),
                        // this.Validate(this.state.rights_father_years, 'Fr7KT', 0),
                    ] : []),
                    ...(this.state.mother_rights4 === true ? [
                        this.Validate(this.state.rights_mother_no, 'Bu8fI', ''),
                        this.Validate(this.state.rights_mother_job_title, 'gKKkV', ''),
                        this.Validate(this.state.rights_mother_department, '1BgFc', ''),
                    ] : []),
                ] : []),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        // Check validation and perform the action based on the step
        switch (step) {
            case 0:
                if (await validateStep0()) {
                    // event0: Perform your action for step 0
                    this.onRenderContent({ mode: 'read', step: step + 1 })
                }
                break;
            case 1:
                if (await validateStep1()) {
                    // event1: Perform your action for step 1
                    this.onRenderContent({ mode: 'read', step: step + 1 })
                }
                break;
            case 2:
                if (await validateStep2()) {
                    // event2: Perform your action for step 2
                    this.onRenderContent({ mode: 'read', step: step + 1 })
                }
                break;
            case 3:
                if (await validateStep3()) {
                    // event3: Perform your action for step 3
                    this.onRenderContent({ mode: 'read', step: step + 1 })
                }
                break;
            case 4:
                if (await validateStep4()) {
                    // event4: Perform your action for step 4
                    this.onRenderContent({ mode: 'read', step: step + 1 })
                }
                break;
            case 5:
                if (this.state.is_linegroup === true) {
                    if (existing === true) {

                        await this.promisedSetState({ loading: true })

                        const responseImage = await fetch(this.state.croppedImage);
                        const blob = await responseImage.blob();

                        const formData = new FormData();
                        formData.append('id', this.state.id);
                        formData.append('applicant_id', this.state.applicant_id);
                        formData.append('year', this.state.year);
                        formData.append('rights1', this.state.rights1);
                        formData.append('rights2', this.state.rights2);
                        formData.append('rights3', this.state.rights3);
                        formData.append('rights4', this.state.rights4);
                        formData.append('id_card_number', this.state.id_card_number);
                        formData.append('first_name', this.state.first_name);
                        formData.append('last_name', this.state.last_name);
                        formData.append('nickname', this.state.nickname);
                        formData.append('date_of_birth', this.state.date_of_birth);
                        formData.append('ethnicity', this.state.ethnicity);
                        formData.append('ethnicity_other', this.state.ethnicity_other);
                        formData.append('reg_house_number', this.state.reg_house_number);
                        formData.append('reg_village_no', this.state.reg_village_no);
                        formData.append('reg_village', this.state.reg_village);
                        formData.append('reg_village_name', this.state.reg_village_name);
                        formData.append('reg_province', this.state.reg_province);
                        formData.append('reg_province_id', this.state.reg_province_id);
                        formData.append('reg_amphur', this.state.reg_amphur);
                        formData.append('reg_amphur_id', this.state.reg_amphur_id);
                        formData.append('reg_tambon', this.state.reg_tambon);
                        formData.append('reg_tambon_id', this.state.reg_tambon_id);
                        formData.append('is_reg_address', this.state.is_reg_address);
                        formData.append('temp_house_number', this.state.temp_house_number);
                        formData.append('temp_village_no', this.state.temp_village_no);
                        formData.append('temp_village', this.state.temp_village);
                        formData.append('temp_village_name', this.state.temp_village_name);
                        formData.append('temp_province', this.state.temp_province);
                        formData.append('temp_province_id', this.state.temp_province_id);
                        formData.append('temp_amphur', this.state.temp_amphur);
                        formData.append('temp_amphur_id', this.state.temp_amphur_id);
                        formData.append('temp_tambon', this.state.temp_tambon);
                        formData.append('temp_tambon_id', this.state.temp_tambon_id);
                        formData.append('phone', this.state.phone);
                        formData.append('is_family_residence', this.state.is_family_residence);
                        formData.append('family_residence_rai', this.state.family_residence_rai);
                        formData.append('family_residence_ngan', this.state.family_residence_ngan);
                        formData.append('family_residence_wah', this.state.family_residence_wah);
                        formData.append('is_family_work', this.state.is_family_work);
                        formData.append('family_work_rai', this.state.family_work_rai);
                        formData.append('family_work_ngan', this.state.family_work_ngan);
                        formData.append('family_work_wah', this.state.family_work_wah);
                        formData.append('is_none_residence', this.state.is_none_residence);
                        formData.append('none_residence_rai', this.state.none_residence_rai);
                        formData.append('none_residence_ngan', this.state.none_residence_ngan);
                        formData.append('none_residence_wah', this.state.none_residence_wah);
                        formData.append('is_none_work', this.state.is_none_work);
                        formData.append('none_work_rai', this.state.none_work_rai);
                        formData.append('none_work_ngan', this.state.none_work_ngan);
                        formData.append('none_work_wah', this.state.none_work_wah);
                        formData.append('edu_level', this.state.edu_level);
                        formData.append('curr_institution', this.state.curr_institution);
                        formData.append('curr_field', this.state.curr_field);
                        formData.append('grades', this.state.grades);
                        formData.append('next_institution', this.state.next_institution);
                        formData.append('next_field', this.state.next_field);
                        formData.append('app_status', this.state.app_status);
                        formData.append('father_full_name', this.state.father_full_name);
                        formData.append('father_age', this.state.father_age);
                        formData.append('father_occupation', this.state.father_occupation);
                        formData.append('father_workplace', this.state.father_workplace);
                        formData.append('father_phone', this.state.father_phone);
                        formData.append('mother_full_name', this.state.mother_full_name);
                        formData.append('mother_age', this.state.mother_age);
                        formData.append('mother_occupation', this.state.mother_occupation);
                        formData.append('mother_workplace', this.state.mother_workplace);
                        formData.append('mother_phone', this.state.mother_phone);
                        formData.append('parent_status', this.state.parent_status);
                        formData.append('parent_status_1', this.state.parent_status_1);
                        formData.append('parent_status_2', this.state.parent_status_2);
                        formData.append('parent_status_3', this.state.parent_status_3);
                        formData.append('parent_status_4', this.state.parent_status_4);
                        formData.append('contactable', this.state.contactable);
                        formData.append('relationship_to_applicant', this.state.relationship_to_applicant);
                        formData.append('total_siblings', this.state.total_siblings);
                        formData.append('working_siblings', this.state.working_siblings);
                        formData.append('siblings_in_school', this.state.siblings_in_school);
                        formData.append('unemployed_siblings', this.state.unemployed_siblings);
                        formData.append('siblings_not_of_age', this.state.siblings_not_of_age);
                        formData.append('family_income_per_year', this.state.family_income_per_year);
                        formData.append('provider_full_name', this.state.provider_full_name);
                        formData.append('provider_relationship', this.state.provider_relationship);
                        formData.append('doitung_activities', this.state.doitung_activities);
                        formData.append('school_activities', this.state.school_activities);
                        formData.append('other_activities', this.state.other_activities);
                        formData.append('applicant_proj_no', this.state.applicant_proj_no);
                        formData.append('father_proj_no', this.state.father_proj_no);
                        formData.append('mother_proj_no', this.state.mother_proj_no);
                        formData.append('father_rights4', this.state.father_rights4);
                        formData.append('rights_father_no', this.state.rights_father_no);
                        formData.append('rights_father_job_title', this.state.rights_father_job_title);
                        formData.append('rights_father_department', this.state.rights_father_department);
                        formData.append('rights_father_years', this.state.rights_father_years);
                        formData.append('mother_rights4', this.state.mother_rights4);
                        formData.append('rights_mother_no', this.state.rights_mother_no);
                        formData.append('rights_mother_job_title', this.state.rights_mother_job_title);
                        formData.append('rights_mother_department', this.state.rights_mother_department);
                        formData.append('rights_mother_years', this.state.rights_mother_years);
                        formData.append('is_linegroup', this.state.is_linegroup);
                        formData.append('image', blob, 'image.png');

                        const response = await axios.put(`${process.env.REACT_APP_API}/application`, formData, this.state.authHeader);

                        const data = response.data;

                        if (data.message === 'successfully') {

                            await this.onRead({ mode: 'read' })

                            await this.promisedSetState({ loading: false })

                            Swal.fire({
                                title: "คุณบันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async (result) => {
                                window.close();
                            })

                        }

                    } else if (existing === false) {

                        await this.promisedSetState({ loading: true })

                        // Create a new FormData object
                        const formData = new FormData();

                        // Append all form fields to FormData
                        formData.append('applicant_id', this.state.applicant_id);
                        formData.append('year', this.state.year);
                        formData.append('rights1', this.state.rights1);
                        formData.append('rights2', this.state.rights2);
                        formData.append('rights3', this.state.rights3);
                        formData.append('rights4', this.state.rights4);
                        formData.append('id_card_number', this.state.id_card_number);
                        formData.append('prefix', this.state.prefix);
                        formData.append('first_name', this.state.first_name);
                        formData.append('last_name', this.state.last_name);
                        formData.append('nickname', this.state.nickname);
                        formData.append('date_of_birth', this.state.date_of_birth);
                        formData.append('ethnicity', this.state.ethnicity);
                        formData.append('ethnicity_other', this.state.ethnicity_other);
                        formData.append('reg_house_number', this.state.reg_house_number);
                        formData.append('reg_village_no', this.state.reg_village_no);
                        formData.append('reg_village', this.state.reg_village);
                        formData.append('reg_village_name', this.state.reg_village_name);
                        formData.append('reg_province', this.state.reg_province);
                        formData.append('reg_province_id', this.state.reg_province_id);
                        formData.append('reg_amphur', this.state.reg_amphur);
                        formData.append('reg_amphur_id', this.state.reg_amphur_id);
                        formData.append('reg_tambon', this.state.reg_tambon);
                        formData.append('reg_tambon_id', this.state.reg_tambon_id);
                        formData.append('is_reg_address', this.state.is_reg_address);
                        formData.append('temp_house_number', this.state.temp_house_number);
                        formData.append('temp_village_no', this.state.temp_village_no);
                        formData.append('temp_village', this.state.temp_village);
                        formData.append('temp_village_name', this.state.temp_village_name);
                        formData.append('temp_province', this.state.temp_province);
                        formData.append('temp_province_id', this.state.temp_province_id);
                        formData.append('temp_amphur', this.state.temp_amphur);
                        formData.append('temp_amphur_id', this.state.temp_amphur_id);
                        formData.append('temp_tambon', this.state.temp_tambon);
                        formData.append('temp_tambon_id', this.state.temp_tambon_id);
                        formData.append('phone', this.state.phone);
                        formData.append('is_family_residence', this.state.is_family_residence);
                        formData.append('family_residence_rai', this.state.family_residence_rai);
                        formData.append('family_residence_ngan', this.state.family_residence_ngan);
                        formData.append('family_residence_wah', this.state.family_residence_wah);
                        formData.append('is_family_work', this.state.is_family_work);
                        formData.append('family_work_rai', this.state.family_work_rai);
                        formData.append('family_work_ngan', this.state.family_work_ngan);
                        formData.append('family_work_wah', this.state.family_work_wah);
                        formData.append('is_none_residence', this.state.is_none_residence);
                        formData.append('none_residence_rai', this.state.none_residence_rai);
                        formData.append('none_residence_ngan', this.state.none_residence_ngan);
                        formData.append('none_residence_wah', this.state.none_residence_wah);
                        formData.append('is_none_work', this.state.is_none_work);
                        formData.append('none_work_rai', this.state.none_work_rai);
                        formData.append('none_work_ngan', this.state.none_work_ngan);
                        formData.append('none_work_wah', this.state.none_work_wah);
                        formData.append('edu_level', this.state.edu_level);
                        formData.append('curr_institution', this.state.curr_institution);
                        formData.append('curr_field', this.state.curr_field);
                        formData.append('grades', this.state.grades);
                        formData.append('next_institution', this.state.next_institution);
                        formData.append('next_field', this.state.next_field);
                        formData.append('app_status', this.state.app_status);
                        formData.append('father_full_name', this.state.father_full_name);
                        formData.append('father_age', this.state.father_age);
                        formData.append('father_occupation', this.state.father_occupation);
                        formData.append('father_workplace', this.state.father_workplace);
                        formData.append('father_phone', this.state.father_phone);
                        formData.append('mother_full_name', this.state.mother_full_name);
                        formData.append('mother_age', this.state.mother_age);
                        formData.append('mother_occupation', this.state.mother_occupation);
                        formData.append('mother_workplace', this.state.mother_workplace);
                        formData.append('mother_phone', this.state.mother_phone);
                        formData.append('parent_status', this.state.parent_status);
                        formData.append('parent_status_1', this.state.parent_status_1);
                        formData.append('parent_status_2', this.state.parent_status_2);
                        formData.append('parent_status_3', this.state.parent_status_3);
                        formData.append('parent_status_4', this.state.parent_status_4);
                        formData.append('contactable', this.state.contactable);
                        formData.append('relationship_to_applicant', this.state.relationship_to_applicant);
                        formData.append('total_siblings', this.state.total_siblings);
                        formData.append('working_siblings', this.state.working_siblings);
                        formData.append('siblings_in_school', this.state.siblings_in_school);
                        formData.append('unemployed_siblings', this.state.unemployed_siblings);
                        formData.append('siblings_not_of_age', this.state.siblings_not_of_age);
                        formData.append('family_income_per_year', this.state.family_income_per_year);
                        formData.append('provider_full_name', this.state.provider_full_name);
                        formData.append('provider_relationship', this.state.provider_relationship);
                        formData.append('doitung_activities', this.state.doitung_activities);
                        formData.append('school_activities', this.state.school_activities);
                        formData.append('other_activities', this.state.other_activities);
                        formData.append('applicant_proj_no', this.state.applicant_proj_no);
                        formData.append('father_proj_no', this.state.father_proj_no);
                        formData.append('mother_proj_no', this.state.mother_proj_no);
                        formData.append('father_rights4', this.state.father_rights4);
                        formData.append('rights_father_no', this.state.rights_father_no);
                        formData.append('rights_father_job_title', this.state.rights_father_job_title);
                        formData.append('rights_father_department', this.state.rights_father_department);
                        formData.append('rights_father_years', this.state.rights_father_years);
                        formData.append('mother_rights4', this.state.mother_rights4);
                        formData.append('rights_mother_no', this.state.rights_mother_no);
                        formData.append('rights_mother_job_title', this.state.rights_mother_job_title);
                        formData.append('rights_mother_department', this.state.rights_mother_department);
                        formData.append('rights_mother_years', this.state.rights_mother_years);
                        formData.append('is_linegroup', this.state.is_linegroup);
                        formData.append('filename', this.state.filename);
                        formData.append('original_name', this.state.original_name);
                        formData.append('path', this.state.path);
                        formData.append('extension', this.state.extension);
                        formData.append('mimetype', this.state.mimetype);
                        formData.append('size', this.state.size);

                        // Convert the image to a Blob and append it to the formData
                        const imageBlob = this.base64ToBlob(this.state.croppedImage.split(',')[1], this.state.croppedImage.split(';')[0].split(':')[1]);
                        formData.append('image', imageBlob, 'image.png');

                        // Send the POST request with FormData
                        const response = await axios.post(`${process.env.REACT_APP_API}/application`, formData, this.state.authHeader);

                        // Handle the response
                        const data = response.data;

                        if (data.message === 'successfully') {

                            await this.onRead({ mode: 'read' })

                            await this.promisedSetState({ loading: false })

                            Swal.fire({
                                title: "คุณบันทึกข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async (result) => {
                                window.close();
                            })
                        }
                    }

                } else if (this.state.is_linegroup === false) {
                    Swal.fire({
                        title: "กรุณาเข้ากลุ่ม Line",
                        icon: "warning",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
                break;
            default:
                console.error(`Unknown step: ${step}`);
                return; // If the step doesn't match, exit the function
        }
    }

    onPrevious = async step => {
        this.onRenderContent({ mode: 'read', step: step - 1 })
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(EditPage);